import { CountryData } from 'types/countries'
import { Country as CountryOption } from 'types/types'

export const getCountryOptions = (data: CountryData[]): CountryOption[] => {
  return data?.map(({ name: label, code: value }) => ({ label, value })) ?? []
}
